export default __webpack_public_path__ + "static/media/line_mobile.8dc33767.svg";